var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsInt, IsObject, IsOptional, IsPositive, IsString, IsUUID, Max, Min, } from 'class-validator';
import { OfficeProductLineItemFullSizeDto } from '../../custom-office-product-line-item/index.js';
import { TaxStatus } from '../../payment/enum/tax-status.enum.js';
import { OfficeProductType } from '../enums/office-product-type.enum.js';
import { OfficeProductAssignmentFullSizeDto } from './office-product-assignment.full-size.dto.js';
export class OfficeProductFullSizeDto {
    id;
    createdAt;
    officeId;
    office;
    updatedAt;
    connectedStripeAccountId;
    connectedStripeAccount;
    /**
     * The display name of the office product.
     */
    name;
    /**
     * The price of the office product in euro-cents.
     */
    price;
    /**
     * The short description of the office product.
     */
    description;
    /**
     * The name of the image-file of the office product.
     */
    image;
    /**
     * True if the office product is visible for patients.
     */
    visible = true;
    /**
     * The type of the office product.
     */
    type = OfficeProductType.THERAME;
    /**
     * The number of therame video calls included in the product.
     */
    therameVideoCallCount = null;
    /**
     * The number of therame exercise programs included in the product.
     */
    therameExerciseProgramCount = null;
    /**
     * The number of days until the product expires.
     */
    expirationDays = 1;
    stripeProductId;
    stripeDefaultPriceId;
    officeProductAssignments;
    officeProductLineItems;
    /**
     * The tax status of the connected stripe account.
     */
    taxStatus;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "office", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    Exclude(),
    IsObject(),
    __metadata("design:type", Function)
], OfficeProductFullSizeDto.prototype, "connectedStripeAccount", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeProductFullSizeDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsPositive(),
    __metadata("design:type", Number)
], OfficeProductFullSizeDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "description", void 0);
__decorate([
    Exclude(),
    IsString(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "image", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeProductFullSizeDto.prototype, "visible", void 0);
__decorate([
    IsEnum(OfficeProductType),
    Expose(),
    __metadata("design:type", String)
], OfficeProductFullSizeDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "therameVideoCallCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "therameExerciseProgramCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    Max(365),
    __metadata("design:type", Number)
], OfficeProductFullSizeDto.prototype, "expirationDays", void 0);
__decorate([
    Exclude(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "stripeProductId", void 0);
__decorate([
    Exclude(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "stripeDefaultPriceId", void 0);
__decorate([
    Exclude(),
    IsOptional(),
    IsArray(),
    Type(() => OfficeProductAssignmentFullSizeDto),
    __metadata("design:type", Array)
], OfficeProductFullSizeDto.prototype, "officeProductAssignments", void 0);
__decorate([
    Expose(),
    IsArray(),
    Type(() => OfficeProductLineItemFullSizeDto),
    __metadata("design:type", Array)
], OfficeProductFullSizeDto.prototype, "officeProductLineItems", void 0);
__decorate([
    Expose(),
    IsEnum(TaxStatus),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeProductFullSizeDto.prototype, "taxStatus", void 0);
//# sourceMappingURL=office-product.full-size.dto.js.map